export default __webpack_public_path__ + "static/media/mail.38c04d85.svg";